import * as R from 'ramda';

import { getClassificationFilterIds } from '../../classifications/classification-filter.utils';
import { CATALOG_FILTERS_KEYS } from './catalogFilters.constants';

const getSuggestedProductsFilter = (customersIds: string[] = [], suggestedProducts?: string) => {
  if (suggestedProducts) {
    return {
      suggestedProductCustomerIds: R.uniq(customersIds),
    };
  }

  return null;
};

export const formatFilterIdsSearchParams = (
  values: Record<string, any> = {},
  customersIds: string[] = [],
) => {
  const { classificationIds, newValues } = getClassificationFilterIds(values);
  const suggestedProductsFilter = getSuggestedProductsFilter(
    customersIds,
    values[CATALOG_FILTERS_KEYS.onlySuggestedProducts],
  );

  if (!suggestedProductsFilter) {
    return {
      ...newValues,
      [CATALOG_FILTERS_KEYS.classifications]: classificationIds,
    };
  }

  return {
    ...newValues,
    ...suggestedProductsFilter,
    [CATALOG_FILTERS_KEYS.classifications]: classificationIds,
  };
};
